export const EVENTS = {
    OPEN_GIVELITHON_LAUNCH: 'Open_Givelithon_Launch',
    SHOW_DONORS: 'Show_Donors',
    HIDE_DONORS: 'Hide_Donors',
    GOAL_COMPLETED: 'Goal_Completed',
};
